import { render, staticRenderFns } from "./ConnectionFailureBase.vue?vue&type=template&id=54a263f3&scoped=true"
import script from "./ConnectionFailureBase.vue?vue&type=script&lang=js"
export * from "./ConnectionFailureBase.vue?vue&type=script&lang=js"
import style0 from "./ConnectionFailureBase.vue?vue&type=style&index=0&id=54a263f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a263f3",
  null
  
)

export default component.exports